import { z } from 'zod';

export const AssignAddOnGroupSchema = z.object({
    addon_group_id: z.string().uuid('Please select a valid optional extra group'),
});

export type AssignAddOnGroupInput = z.infer<typeof AssignAddOnGroupSchema>;
